"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROCESS_DONATION_CART_ITEMS = exports.MERGE_CART_ITEMS_TO_BUNDLE = exports.SET_SHIPPING_CART = exports.ADD_CART_SHIPPING_ADDRESS = exports.REMOVE_PROMO = exports.ADD_PROMO = exports.REMOVE_CART_ITEMS = exports.UPDATE_CART_ITEM = exports.ADD_BUNDLE_CART_ITEM = exports.ADD_MEMBERSHIP_TO_CART = exports.ADD_CART_ITEM = exports.MIGRATE_CART = exports.AUTO_RENEW_MEMBERSHIP_DISCOUNT_USED = exports.GET_CART = void 0;
exports.GET_CART = `
  query getCart($cartId: String, $recalculate: Boolean, $addUpsellInfo: Boolean) {
    getCart(cartId: $cartId, recalculate: $recalculate, addUpsellInfo: $addUpsellInfo)
  }
`;
exports.AUTO_RENEW_MEMBERSHIP_DISCOUNT_USED = `
  query autoRenewMembershipDiscountUsed {
    autoRenewMembershipDiscountUsed
  }
`;
exports.MIGRATE_CART = `
  mutation migrateCart($cartId: String, $cartVersion: Int, $currencyLabel: String, $userLocation: String, $useProductsPriceCurrency: Boolean ) {
    migrateCart(cartId: $cartId, cartVersion: $cartVersion, currencyLabel: $currencyLabel, userLocation: $userLocation, useProductsPriceCurrency: $useProductsPriceCurrency )
  }
`;
exports.ADD_CART_ITEM = `
  mutation addCartItem($cartId: String, $productId: String, $variantSKU: String, $quantity: Int, $standingOrder: Boolean, $asPartOfToBundleId: String, $donationPrice: String, $freeTrial: Boolean, $currencyLabel: String, $userLocation: String, $useProductsPriceCurrency: Boolean, $ethicStatus: Boolean, $activeMIPSubscription: JSON ) {
	  addCartItem(cartId: $cartId, productId: $productId, variantSKU: $variantSKU, quantity: $quantity, standingOrder: $standingOrder, asPartOfToBundleId: $asPartOfToBundleId, donationPrice: $donationPrice, freeTrial: $freeTrial, currencyLabel: $currencyLabel, userLocation: $userLocation, useProductsPriceCurrency: $useProductsPriceCurrency,ethicStatus: $ethicStatus, activeMIPSubscription: $activeMIPSubscription )
  }
`;
exports.ADD_MEMBERSHIP_TO_CART = `
  mutation addMembershipToCart($data: JSON, $currencyLabel: String, $userLocation: String) {
    addMembershipToCart(data: $data, currencyLabel: $currencyLabel, userLocation: $userLocation) 
    }
`;
exports.ADD_BUNDLE_CART_ITEM = `
  mutation addBundleCartItem($cartId: String, $productIds: [String], $variantSKUs: [VariantInfo], $bundleId: String, $ethicStatus: Boolean) {
	  addBundleCartItem(cartId: $cartId, productIds: $productIds, variantSKUs: $variantSKUs, bundleId: $bundleId, ethicStatus: $ethicStatus )
  }
`;
exports.UPDATE_CART_ITEM = `
  mutation updateCartItem($cartId: String, $cartVersion: Int, $lineItemId: String, $quantity: Int, $standingOrder: Boolean, $shippingMethodKey: String, $bundleId: String, $donationPrice: String ) {
	  updateCartItem(cartId: $cartId, cartVersion: $cartVersion, lineItemId: $lineItemId, quantity: $quantity, standingOrder: $standingOrder, shippingMethodKey: $shippingMethodKey, bundleId: $bundleId, donationPrice: $donationPrice )
  }
`;
exports.REMOVE_CART_ITEMS = `
mutation removeCartItems($cartId: String, $cartVersion: Int, $lineItemIds: [String]) {
  removeCartItems(cartId: $cartId, cartVersion: $cartVersion, lineItemIds: $lineItemIds)
}`;
exports.ADD_PROMO = `
mutation addPromoCodeToCart($cartId: String, $cartVersion: Int, $promoCode: String, $addUpsellInfo: Boolean, $organizationId: String, $isPromoCodeExemption: Boolean, $isSearchingDiscountCode: Boolean) {
	addPromoCodeToCart(cartId: $cartId, cartVersion: $cartVersion, promoCode: $promoCode, addUpsellInfo: $addUpsellInfo, organizationId: $organizationId, isPromoCodeExemption: $isPromoCodeExemption, isSearchingDiscountCode: $isSearchingDiscountCode)
}`;
exports.REMOVE_PROMO = `
mutation removePromoCodeFromCart($cartId: String, $cartVersion: Int, $promoId: String, $addUpsellInfo: Boolean) {
	removePromoCodeFromCart(cartId: $cartId, cartVersion: $cartVersion, promoId: $promoId, addUpsellInfo: $addUpsellInfo)
}`;
exports.ADD_CART_SHIPPING_ADDRESS = `
  mutation addShippingAddress($cartId: String, $cartVersion: Int, $addressLine1: String, $addressLine2: String, $city: String, $state: String, $zipCode: String, $country: String, $shippingTypeKey: String){
    addShippingAddress(cartId: $cartId, cartVersion: $cartVersion, addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, state: $state, zipCode: $zipCode, country: $country, shippingTypeKey: $shippingTypeKey)
  }
`;
exports.SET_SHIPPING_CART = `
  mutation setShippingOption($cartId: String, $cartVersion: Int, $shippingOption: String ) {
	  setShippingOption(cartId: $cartId, cartVersion: $cartVersion, shippingOption: $shippingOption )
  }
`;
exports.MERGE_CART_ITEMS_TO_BUNDLE = `
  mutation mergeItemsToBundle($cartId: String, $bundleId: String! ) {
	  mergeItemsToBundle(cartId: $cartId, bundleId: $bundleId )
  }
`;
exports.PROCESS_DONATION_CART_ITEMS = `
  mutation processDonationCartItems($membershipDonationInfo: [MembershipDonationInfo]) {
	  processDonationCartItems(membershipDonationInfo: $membershipDonationInfo)
  }
`;
//# sourceMappingURL=cart-queries.js.map